import axios from "axios";
import { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from 'sweetalert2';
import { DashboardContext } from "../dashboard/DashboardContext";
import { BaseUrlContext } from "../context/BaseUrlContext";

export const UserContext = createContext();

export const UserProvider = ({children})=>{
  const { BaseUrl } = useContext(BaseUrlContext);
  const {userData,token,allReports,tokenKey,setTokenKey,fetchReports}=useContext(DashboardContext);
        const navigate = useNavigate();
        const [users, setUsers] = useState([]);
        const [error, setError] = useState([]);
      const [showCreateModal, setShowCreateModal] = useState(false);
      const [showEditModal, setShowEditModal] = useState(false);
      const [showDeleteModal, setShowDeleteModal] = useState(false);
      const [selectedUser, setSelectedUser] = useState(null);

      // console.log(userData, "users122");
     
      const handleLogout = () => {
        navigate("/");
      };
    // .............................................................................
      const initialFormData={
        userName: "",
        userPassword: "",
        userType: "",
        userAdmin: ""
      }
      const [formData, setFormData] = useState(initialFormData);
    // .............................................................................
    const handleChange = (e) => {
        const { name, value } = e.target;
      setFormData((prevData) => ({
        ...prevData,
        [name]: value
      }));
    }
    //..............................................................................
        const clearFormData = () => {
            setFormData(initialFormData);
            setError([]);
        }
      const handleOpenCreateModal = () =>{
        setShowCreateModal(true);
      } 
      const handleCloseCreateModal = () => {
        setShowCreateModal(false);
        clearFormData();
      };
      const handleOpenEditModal = (row) => {
        setShowEditModal(true);
        setFormData(row);
      }
      const handleCloseEditModal = () => {
        setShowEditModal(false);
        clearFormData();
      };
      const handleOpenDeleteModal = (row) => {
        setSelectedUser(row);
        setShowDeleteModal(true);
      };
      const handleCloseDeleteModal = () => {
        setSelectedUser(null);
         setShowDeleteModal(false);
};
    // .............................................................................
    const handleSubmit = (e) => {
  // console.log(formData, "Form Data1");
  e.preventDefault();

  axios.post(`${BaseUrl}user/create`, formData,{
    headers: { Authorization: `Bearer ${tokenKey}` }
  })
    .then((res) => {
      // console.log(res.data, "Response Data1234");
      setUsers([...users, res.data]);
      toast.success("User Created Successfully");
      handleCloseCreateModal();
      setError("");
    })
    .catch((err) => {
      // console.log("Error detail12:", err);

      let errorMessage = "Error submitting form";

      if (err.response) {
        if (err.response.status === 500) {
          errorMessage = "This user already exists!";
        } else if (err.response.status === 409) {
          errorMessage = "Duplicate entry.User already exists!";
        }else if (err.response.status === 401) {
          errorMessage = "Duplicate entry.User already exists!";
        } else {
          errorMessage = err.response.data || "Something went wrong!";
        }
      } else {
        errorMessage = "Network error or server is not responding";
      }

      setError(errorMessage); 
      toast.error(errorMessage);
    })
};

    // .............................................................................
    const handleUpdate = (e,uname) => {
        e.preventDefault();
        axios.put(`${BaseUrl}user/update/${uname}`,formData,{
          headers: { Authorization: `Bearer ${tokenKey}` }
        })
        .then((res) => {
          //  setUsers(res.data);
          axios.get(`${BaseUrl}user/getAll`,{
            headers: { Authorization: `Bearer ${tokenKey}` }
          })
          .then((res) => {
            setUsers(res.data);
          })
          toast.success("User Updated Successfully");
          handleCloseEditModal();
        })
        .catch((err) => {
        // console.log('Error details1', err);
        const errorMessage = err.response ? (err.response.status === 500 ? 'This value already exists!' : err.response.data || 'Error submitting form') : 'Network error or server is not responding';
        toast.error(errorMessage); 
        })
    }
// -------------------------------------------------------------------------------------
const handleDelete = async (row) => {
  const result = await Swal.fire({
    text: `Do you really want to delete "${row.userName}"?`,
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    confirmButtonColor: "#00ABEF",
    cancelButtonColor: "#6c757b",
    background: "#dceff7ff",
    color: "#1f2937",
    width: "400px",
    position: 'top', 
    customClass: {
      popup: "small-alert",
      confirmButton: "px-2 py-1 text-sm",
      cancelButton: "px-2 py-1 text-sm"
    }
  });

  if (result.isConfirmed) {
    try {
      await axios.delete(`${BaseUrl}user/delete/${row.userName}`,{
        headers: { Authorization: `Bearer ${tokenKey}` }
      });
      toast.success("User Deleted Successfully");
      setUsers(users.filter((u) => u.userName !== row.userName));
    } catch (err) {
      // console.error("Delete error:", err);
    }
  }
};

// .............................................................................
    return (<UserContext.Provider value={{
        users,
        setUsers,
        showCreateModal,
        setShowCreateModal,
        showEditModal,
        setShowEditModal,
        handleLogout,
        handleOpenCreateModal,
        handleCloseCreateModal,
        handleOpenEditModal,
        handleCloseEditModal,
        handleChange,
        handleSubmit,
        handleUpdate,
        handleDelete,
        formData,
        setFormData,
        error,
        setError,
        showDeleteModal,
        setShowDeleteModal,
        handleOpenDeleteModal,
        handleCloseDeleteModal,
        selectedUser,
        setSelectedUser,

    }}>
        {children}
        </UserContext.Provider>)
};